import { render, staticRenderFns } from "./InstagramEmbed.vue?vue&type=template&id=07020eb4&scoped=true&"
import script from "./InstagramEmbed.vue?vue&type=script&lang=ts&"
export * from "./InstagramEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramEmbed.vue?vue&type=style&index=0&id=07020eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07020eb4",
  null
  
)

component.options.__file = "InstagramEmbed.vue"
export default component.exports